// extracted by mini-css-extract-plugin
export default {"gameboard":"Gameboard_gameboard__nxF41"};